import React from "react";
// styles
import useStyles from "./styles";

import { Grid,useTheme,Chip,Checkbox } from "@material-ui/core";
import { Typography } from "../../components/Wrappers";
import parse from "html-react-parser";
import Lineitemdetailview from './Lineitemdetailview';
 
// FormInput
import { FormInput } from "../";
import {pathOr} from "ramda";
import {  useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { saveAs } from 'file-saver';
import { toast } from "react-toastify";

import VisibilityIcon from '@material-ui/icons/Visibility';
import { useState } from "react";
import FileViewerComp from "../FileViewer/FileViewer";
import { Tooltip } from "@material-ui/core";
import {Reminders, ReminderTime} from "../FormComponents";

export default function ViewRows({
  data,
  module,
  initialValues,
  errors,
  onChange,
  view = "editview",
  setEmailModal,
  recordId,
  quickCreate=false,
  hiddenAll,
  mode = "detailpanel"
  
}) {
 
  const [previewFile, setPreviewFile] = useState({open:false,filename:"",filepath:""});
  
  function truncate(str,n) {
    return str?.length > n ? str.substr(0,n-1) + "..." : str;
  }
  const [value, setValue] = React.useState({});
  const [inputValue, setInputValue] = React.useState("");

  const [options, setOptions] = React.useState([]);

  const  handleShowPreviewFile = (fname,url) =>{
    let arr = fname.split(".");
    let ext = arr[arr.length-1].toUpperCase();
    setPreviewFile({open:true,filename:fname,filepath:url,filetype:ext});
  }

  const classes = useStyles();  
  const { currentUserData,config,userPreference} = useSelector(
    (state) => state.config,
  );
  const statusBackground = pathOr([],["fields_background", module],config);
  const site_url = pathOr("",["site_url"],config);
  const isAdmin = pathOr(0,['data','attributes','is_admin'],currentUserData);
  const HideShowCustomizations = pathOr([],['attributes','HideShowCustomizations',module,0],userPreference);

  // console.log("HideShowCustomizations",HideShowCustomizations)
  let statusField = Object.keys(statusBackground);
  const currentTheme = useTheme();
  // console.log("statusField ",statusField);
  const parseFieldValue = (field, value) => {
    // console.log("field")
    // console.log(field)
    // alert('fields');
    if (statusField && statusField.length > 0 && statusField.indexOf(field.field_key) >= 0 && view === 'detailview') {
      //console.log("fieldoptions ",field.field_key);
      let option = (field.options) ? Object.keys(field.options).find(key => field.options[key] === value) : '';
      let optionBgColor = `${pathOr("", [field.name, option, "background_color"], statusBackground)}`;
      let statusStyle = {};

      if (currentTheme.palette.type === 'dark') {
        statusStyle = { color: optionBgColor, fontWeight: 'bolder', background: 'transparent', border: '1px solid' };

      } else {
        statusStyle = { color: optionBgColor, background: optionBgColor + "20", border: 'none', };
      }
      return (
        value && optionBgColor ? <Chip size="small" className={classes.statusBg} style={statusStyle} label={value} /> : value
      )
    }
    if (field.field_key === "opportunities_scoring_c" || field.field_key==="lead_scoring_c") {
      if (
        value &&
        value != null &&
        typeof value == "string"
      ) {
        let tmp = document.createElement("SPAN");
        tmp.innerHTML = value;
        return (value = tmp.textContent || tmp.innerText || "");
      }
    }
    if (/<\/?[a-z][\s\S]*>/i.test(value) && view !== 'editview' && field.type==='wysiwyg') {
      return parse(value);
    }
    if(field.field_key==="description")
    {
      // alert("TYPE DESCRIPTION")
      // console.log(field);
      if(value &&
        value != null &&
        typeof value == "string")
        {
          switch (view) {
            case "createview":
              return (value = ""); 

            case "detailview":
              let tmp = document.createElement("div");
              tmp.textContent = parse(value);
              // console.log(tmp.textContent);
              return (value = tmp.textContent || tmp.innerText || "");
            
            default:
              let tmp1 = document.createElement("div");
              tmp1.textContent = value;
              // console.log(tmp1.textContent);
              return (value = tmp1.textContent || tmp1.innerText || "");    
          }
        }
    }
    //to parse address field
    if (field.field_key === field.field_key.substr(0, field.field_key.indexOf("_"))+"_address_street") {
      value = addressString(field);
    }
    if((field.field_key=='email1' || field.type==='email') && Array.isArray(field.value))
    {
      return emailString(field);
    }
    if(field.field_key==='converted' && view === 'detailview')
    {
      return field.value==1?'Yes':'No';
    }
    if(field.type==='bool' && view === 'detailview')
    {
      return <Checkbox disabled checked={field.value==1} style={{padding:0}} />;
    }
    if(field.type==='parent' && view === 'detailview')
    {
      return (<Typography>
      <Link
        to={`/app/detailview/${field.parent_name.parent_type}/${field.parent_name.parent_id}`}
        className={classes.link}
        // component="button"
        variant="body2"
      >
        {value}
      </Link>
    </Typography>);
    }
    if(field.type==='relate' && view === 'detailview')
    {
      const ss = field.id_name;
      return (<Typography>
      <Link
        to={`/app/detailview/${field.module}/${field[ss]}`}
        className={classes.link}
        // component="button"
        variant="body2"
      >
        {value}
      </Link>
    </Typography>);
    }
    if(field.type==='file' && view === 'detailview')
    {
      let furl = `${site_url}/index.php?entryPoint=customDownload&id=${recordId}&type=${module}`;
      return (<Typography>
      <Tooltip title={value}>
      <Link to={`#`} className={classes.fileNameLinkTxt} onClick={()=>{saveAs(furl, value); toast("Downloading in progress!");}} variant="body2">
        {truncate(value,20)}
      </Link>
      </Tooltip>      
      {value ? <VisibilityIcon fontSize='small' style={{margin:"-1vh",marginLeft:"1vh",marginRight:"1vw",cursor:"pointer"}} 
        onClick={()=>handleShowPreviewFile(value,furl)}>
      </VisibilityIcon > : ""}
    </Typography>);
    }
    if(field.type==='image' && field.value && view === 'detailview')
    {
      return <img src={field.value} alt={field.label} className={classes.photo} />;
    }
    if(field.name=='reminders')
    {
      // alert("REMINDER FILED VALUE")
      // console.log(field)
        return <Reminders 
        field={field} 
        onChange={(val) => {return val;}} 
        errors = {""} 
        variant = "outlined" 
        value={field.value} 
        small = {false} 
        disabled={true}
        view={"detailview"}
        />
        
      }
    // {alert(field.name)}
    if(field.name=='reminder_time')
    {
        // console.log(field.value)
        return <ReminderTime
          field={field}
          errors={""}
          value={field.value} 
          disabled={true}
          onChange={(val) => {return val;}}
          view={"detailview"}
        />
    }
    if(mode==='rightpanel' && field.type==='text' && field.color){
      return <Typography style={{color:field.color}}>{field.value}</Typography>;
    }

    return value;
  };
  const emailString=(field)=>{
    return  field.value.map((email,key)=>(
      <p style={{margin:0}}><Link to="#" className={classes.emailLink} variant="body2" onClick={(e)=>{e.preventDefault(); setEmailModal({visible:true,to:email.email});}}>{email.email} {(email.primary)?'(primary)':''}</Link></p>
    ))
  }
  const addressString =(field)=>{
    let value = '';
    let address_street = pathOr(null,[field.name.substr(0, field.name.indexOf("_"))+"_address_street"],field.value);
    let address_city = pathOr(null,[field.name.substr(0, field.name.indexOf("_"))+"_address_city"],field.value);
    let address_state = pathOr(null,[field.name.substr(0, field.name.indexOf("_"))+"_address_state"],field.value);
    let address_postalcode = pathOr(null,[field.name.substr(0, field.name.indexOf("_"))+"_address_postalcode"],field.value);
    let address_country = pathOr(null,[field.name.substr(0, field.name.indexOf("_"))+"_address_country"],field.value);

    value = address_street;
    value += address_city?address_city+', ':'';
    value += address_state?address_state+', ':'';
    value += address_postalcode?address_postalcode+', ':'';
    value += address_country;
    return value;
  }
  const isDisabled =(field)=>{
    if(field.field_key === "case_number" &&  view === 'editview')
    {
      return true;
    }
    if(field.field_key === "opportunities_scoring_c" || field.field_key==="lead_scoring_c")
    {
      return true;
    }
    if(module==='Users' && field.field_key==='UserType' && isAdmin!=1)
    {
      return true;
    }
    if(module==='Meetings' && field.field_key==='duration')
    {
      return true;
    }
    if(hiddenAll['disabled'].find(o => o === field.name)){
      return true;
    }
    return false;
  }
  //console.log("hiddenAll",hiddenAll);
  return (
    <Grid container>
      {data.attributes.map((row, rowNum) => (
        <Grid container spacing={3} key={rowNum}>
          
          {row.map((field, fieldNum) => (
             hiddenAll && hiddenAll['hidden'] && !hiddenAll['hidden'].find(o => o === field.name) ?
            <Grid item xs={12} sm={row.length == 2 ? 6 : 12} key={fieldNum}>

              <Grid
                container
                className={classes.fieldSpacing}
                direction="row"
                justify="space-between"
                alignItems="stretch"
                
              >
                {(view === "editview") && (module === 'AOS_Quotes' || module === 'AOS_Invoices') && (field.name === 'total_amt' || field.name === 'discount_amount' || field.name === 'subtotal_amount' || field.name === 'shipping_amount' || field.name === 'shipping_tax_amt' || field.name === 'shipping_tax' || field.name === 'tax_amount' || field.name === 'total_amount') ?
                  (<><Grid item xs>
                  </Grid>
                    < Grid item xs>
                    </Grid></>)
                  : null
                }
                <Grid item xs>
                {/* HideShowCustomizations['hiddenAlways'].indexOf(field.field_key) === -1? */}
                {/* {console.log("viewwwww",view,initialValues)} */}
               {view === "editview" && field.field_key? (
               <>
                      <FormInput
                      field={field}
                      initialValues={initialValues}
                      value={
                        (field?.field_key!=="effort_estimated_c" ? parseFieldValue(field, initialValues[field.name]) || "" : field.value) ||
                        (field?.field_key!=="effort_c" ? parseFieldValue(field, initialValues[field.name]) || "" : field.value)
                      }
                      dynamicEnumValue={initialValues[field.parentenum] || ""}
                      errors={errors}
                      module={module}
                      small={true}
                      onChange={(val) => onChange(field, val)}
                      disabled={isDisabled(field) } // || HideShowCustomizations['disabledAlways'].indexOf(field.field_key) !== -1
                      view={view}
                      quickCreate={quickCreate}
                    />
                    </>
                  ) : (
                      <Grid
                        container
                        direction="row"
                        justify={(field.field_key === 'total_amt' || field.field_key === 'discount_amount' || field.field_key === 'subtotal_amount' || field.field_key === 'shipping_amount' || field.field_key === 'shipping_tax_amt' || field.field_key === 'shipping_tax' || field.field_key === 'tax_amount' || field.field_key === 'total_amount') && (module === 'AOS_Quotes' || module === 'AOS_Invoices') ?'flex-end':'space-between'}
                        alignItems="stretch"
                      >
                        <Grid item xs={mode === 'rightpanel' ? 12 : row.length === 2 ? 4 : 2}>
                          <Typography
                            className={classes.text}
                            variant="subtitle2"
                          >
                            {field.label ? field.label + " :" : ""}
                          </Typography>
                        </Grid>
                        { field.field_key==="description" ?
                        (<Grid item xs={mode === 'rightpanel' ? 12 : row.length === 2 ? 8 : 10}
                        style={{maxWidth:(field.field_key === 'total_amt' || field.field_key === 'discount_amount' || field.field_key === 'subtotal_amount' || field.field_key === 'shipping_amount' || field.field_key === 'shipping_tax_amt' || field.field_key === 'shipping_tax' || field.field_key === 'tax_amount' || field.field_key === 'total_amount') && (module === 'AOS_Quotes' || module === 'AOS_Invoices') ?'150px':'auto', whiteSpace:"break-spaces"}}>
                          <Typography
                            className={classes.text}
                            variant="subtitle1"                            
                            style={{ paddingLeft: row.length === 2 ? 6 : null,textAlign:(field.field_key === 'total_amt' || field.field_key === 'discount_amount' || field.field_key === 'subtotal_amount' || field.field_key === 'shipping_amount' || field.field_key === 'shipping_tax_amt' || field.field_key === 'shipping_tax' || field.field_key === 'tax_amount' || field.field_key === 'total_amount') && (module === 'AOS_Quotes' || module === 'AOS_Invoices') ?'right':'unset' }}
                          >
                            {field.field_key === 'line_items' && (module === 'AOS_Quotes' || module === 'AOS_Invoices') ? <Lineitemdetailview data={field.linedata} /> :
                              parseFieldValue(field, field.value)}                            
                          </Typography>
                        </Grid>) : (
                          <Grid item xs={mode === 'rightpanel' ? 12 : row.length === 2 ? 8 : 10}
                        style={{maxWidth:(field.field_key === 'total_amt' || field.field_key === 'discount_amount' || field.field_key === 'subtotal_amount' || field.field_key === 'shipping_amount' || field.field_key === 'shipping_tax_amt' || field.field_key === 'shipping_tax' || field.field_key === 'tax_amount' || field.field_key === 'total_amount') && (module === 'AOS_Quotes' || module === 'AOS_Invoices') ?'150px':'auto'}}>
                          <Typography
                            className={classes.text}
                            variant="subtitle1"                            
                            style={{ paddingLeft: row.length === 2 ? 6 : null,textAlign:(field.field_key === 'total_amt' || field.field_key === 'discount_amount' || field.field_key === 'subtotal_amount' || field.field_key === 'shipping_amount' || field.field_key === 'shipping_tax_amt' || field.field_key === 'shipping_tax' || field.field_key === 'tax_amount' || field.field_key === 'total_amount') && (module === 'AOS_Quotes' || module === 'AOS_Invoices') ?'right':'unset' }}
                          >
                            {field.field_key === 'line_items' && (module === 'AOS_Quotes' || module === 'AOS_Invoices') ? <Lineitemdetailview data={field.linedata} /> :
                              parseFieldValue(field, field.value)}                            
                          </Typography>

                        </Grid>
                        )}
                      </Grid>
                    )}
                </Grid>
              </Grid>
            </Grid>
          :null
          )
          
          )}
        </Grid>
      ))
      
      }
      {(previewFile.open) ? <FileViewerComp previewFile={previewFile} setPreviewFile={setPreviewFile} /> : ""}
    </Grid >
  );
}
